import RegisterElement from "../components/RegisterStorageElement"
import ViewRegisterEntry from "../components/registerviews/register-entry/ViewRegisterEntry"
import ViewRegisterExit from "../components/registerviews/register-exit/ViewRegisterExit"
import ViewStorageList from "../components/tabledataviews/storage-list/ViewStorageItemList"
import ViewMovementsList from "../components/tabledataviews/movements-list/ViewMovementsList"
import ViewPendingEntries from "../components/tabledataviews/movements-pending/ViewPendingEntries"
import ViewPendingExits from "../components/tabledataviews/movements-pending/ViewPendingExits"
import ViewStoreItemList from "../components/tabledataviews/store-list/ViewStoreItemList"
import ViewUserContactList from "../components/tabledataviews/contacts-list/ViewUserContactList"
import ViewSettings from "../components/ViewSettings"
import ViewMovementDetail from "../components/ViewMovementDetail"
import ViewStockOverrideList from "../components/tabledataviews/movements-pending/ViewStockOverrideList"
import ViewStorageReports from "../components/tabledataviews/reports/ViewStorageReports"
import ViewTraceabilityList from "../components/tabledataviews/traceability/ViewTraceabilityList"
import ViewEcommerceManagement from "../components/tabledataviews/ecommerce/ViewEcommerceManagement"

export const modules = {
  PendingEntriesList: "PENDING_ENTRIES_LIST",
  PendingExitsList: "PENDING_EXITS_LIST",
  StockOverrideList: "STOCK_OVERRIDE_LIST",
  RegisterStorageItem: "REGISTER_STORAGE_ITEM",
  RegisterEntry: "REGISTER_ENTRY",
  RegisterExit: "REGISTER_EXIT",
  EditStorageItem: "EDIT_STORAGE_ITEM",
  StorageItemList: "STORAGE_ITEM_LIST",
  MovementList: "MOVEMENT_LIST",
  StoreList: "STORE_LIST",
  ContactList: "CONTACT_LIST",
  Settings: "SETTINGS",
  MovementDetail: "MOVEMENT_DETAIL",
  StorageReports: "STORAGE_REPORTS",
  Traceability: "TRACEABILITY",
  EcommerceManagement: "ECOMMERCE_MANAGEMENT"
} as const

export const contentPath = {
  [modules.RegisterStorageItem]: "/register-storage-item",
  [modules.RegisterEntry]: "/register-entry",
  [modules.RegisterExit]:"/register-exit",
  [modules.StorageItemList]: "/storage-item-list",
  [modules.MovementList]: "/movements",
  [modules.PendingEntriesList]:"/pending-entries",
  [modules.PendingExitsList]: "/pending-exits",
  [modules.StockOverrideList]: "/stock-override-list",
  [modules.EditStorageItem]: "/edit-storage-item/:uidItem?",
  [modules.StoreList]: "/store-list",
  [modules.ContactList]: "/contacts-list",
  [modules.Settings]: "/settings",
  [modules.MovementDetail]: "/movement/:id",
  [modules.StorageReports]: "/storage-reports",
  [modules.Traceability]: "/traceability",
  [modules.EcommerceManagement]: "/ecommerce"
} as const

export const contentLayout = {
  [modules.RegisterStorageItem]: RegisterElement,
  [modules.RegisterEntry]: ViewRegisterEntry,
  [modules.RegisterExit]:ViewRegisterExit,
  [modules.StorageItemList]: ViewStorageList,
  [modules.MovementList]: ViewMovementsList,
  [modules.PendingEntriesList]:ViewPendingEntries,
  [modules.PendingExitsList]: ViewPendingExits,
  [modules.StockOverrideList]: ViewStockOverrideList,
  [modules.EditStorageItem]: RegisterElement,
  [modules.StoreList]: ViewStoreItemList,
  [modules.ContactList]: ViewUserContactList,
  [modules.Settings]: ViewSettings,
  [modules.MovementDetail]: ViewMovementDetail,
  [modules.StorageReports]: ViewStorageReports,
  [modules.Traceability]: ViewTraceabilityList,
  [modules.EcommerceManagement]: ViewEcommerceManagement
} as const
